import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderComp from '../Header/Header';
import './favorite.css';

function FavoriteComp() {
  const [userData, setuserData] = useState({});
  const [menuHeaderOpen, setMenuHeaderOpen] = useState(false);
  const navigate = useNavigate();

  const [favoriteBooks, setFavoriteBooks] = useState([
    {
      id: 'tanya',
      title: 'ספר התניא',
      description: 'ספר היסוד של חסידות חב״ד, מאת האדמו״ר הזקן.',
    },
    {
      id: 'vatah-tetzaveh',
      title: 'מאמר ואתה תצוה',
      description: 'מאמר עמוק ונשגב של הרבי, עוסק בתפקידו של משה רבנו.',
    },
    {
      id: 'igrot',
      title: 'אגרות קודש',
      description: 'מכתבים מעוררי השראה ומדריכים של הרבי בתחומים שונים.',
    },
  ]);

  const goToBook = (id) => {
    navigate(`/tanya/${id}`);
  };

  const removeFavorite = (id) => {
    setFavoriteBooks(prev => prev.filter(item => item.id !== id));
  };

  return (
    <div className="tanya-container">
      <HeaderComp
        userData={userData}
        menuHeaderOpen={menuHeaderOpen}
        setMenuHeaderOpen={setMenuHeaderOpen}
      />

      <div className="favorites-wrapper">
        <h2 className="favorites-title">המועדפים שלי</h2>

        <div className="favorites-list">
          {favoriteBooks.map(book => (
            <div className="favorite-card" key={book.id}>
              <div className="card-header">
                <h3>{book.title}</h3>
                <button
                  className="remove-button"
                  onClick={() => removeFavorite(book.id)}
                  title="הסר מהמועדפים"
                >
                  🤍
                </button>
              </div>
              {/* <p>{book.description}</p> */}
              {/* <button onClick={() => goToBook(book.id)}>קרא עכשיו</button> */}
            </div>

          ))}
        </div>

        <button className="button back-button" onClick={() => navigate("/tanya")}>
          ⬅ חזור
        </button>
      </div>
    </div>
  );
}

export default FavoriteComp;
